export const USER_SEARCH_SELECTOR = '#filters-container'
export const FOOTER_SELECTOR = '.footer'